import React from 'react';

const ToolsMarquee = () => {
  const tools = [
    {
      name: 'Kit.com',
      logo: '/assets/marquee/kit-logo-soft-black.svg'
    },
    {
      name: 'Mailchimp',
      logo: '/assets/marquee/mailchimp.webp'
    },
    {
      name: 'ActiveCampaign',
      logo: '/assets/marquee/activecampaign-logo.webp'
    },
    {
      name: 'GoHighLevel',
      logo: '/assets/marquee/ghl-logo.webp'
    },
    {
      name: 'Beehiiv',
      logo: '/assets/marquee/beehiiv.webp'
    },
    {
      name: 'Make',
      logo: '/assets/marquee/make-logo.webp'
    },
    {
      name: 'ManyChat',
      logo: '/assets/marquee/manychat-logo.webp'
    },
    {
      name: 'Miro',
      logo: '/assets/marquee/miro-logo.webp'
    },
    {
      name: 'SendGrid',
      logo: '/assets/marquee/sendgrid.webp'
    },
    {
      name: 'Zapier',
      logo: '/assets/marquee/zapier_logo.webp'
    }
  ];

  // Duplicate the tools array for seamless infinite scroll
  const duplicatedTools = [...tools, ...tools, ...tools];

  return (
    <section className="py-14 bg-cream-2 overflow-hidden border-y border-line" data-testid="tools-marquee">
      <div className="mb-10 text-center">
        <p className="text-xs uppercase tracking-[0.25em] text-[var(--gh-orange)] font-semibold">
          Tools & platforms we master
        </p>
      </div>
      
      <div className="relative overflow-hidden">
        <div className="flex gap-12 animate-scroll-infinite whitespace-nowrap">
          {duplicatedTools.map((tool, index) => (
            <div
              key={`${tool.name}-${index}`}
              className="flex-shrink-0 flex items-center justify-center w-32 h-16 grayscale hover:grayscale-0 transition-all duration-300 opacity-60 hover:opacity-100"
            >
              <img
                src={tool.logo}
                alt={`${tool.name} - Email Marketing Platform Logo`}
                title={tool.name}
                loading="lazy"
                decoding="async"
                width="128"
                height="64"
                className="max-w-full max-h-full object-contain"
                style={{
                  mixBlendMode: 'multiply',
                  filter: 'contrast(1.2) brightness(1.05)'
                }}
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ToolsMarquee;
